import { useEffect, useState } from "react";
import { ReportsService } from "../reportsService";
import { useNavigate } from "react-router-dom";
import { InitializeMarketingReport } from "../reportsColumn";
import { buildRegionizeRoute } from "../../../helpers/regionRouteHelper";
import { AppRoutes } from "../../../constants/appRoutes";
import DataTableGrid from "../../../shared/formUtilities/useTable";
import { DateHelper } from "../../../helpers/dateHelper";
import { saveAs } from "file-saver";
import { MarketingFilter } from "./marketingFilter"
import FilterHelper from '../../../helpers/filterHelper';
import {MarketingSchema} from "../../../../src/shared//validations/schema";
import { Formik, Form } from "formik";

export const MarketingReport = () => {
  const reportsService = new ReportsService();
  const [crsData, setCrsData] = useState([]);
  const [loading, setloading] = useState(false);

  // Active filters stored in state
  const [activeFilters, setActiveFilters] = useState({
    fromDate: null,
    toDate: null,
  });

  const navigate = useNavigate();
  const columns = InitializeMarketingReport();
  const queryParameters = new URLSearchParams(window.location.search);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageCount: 0,
    perPage: 10,
    totalCount: 0,
  });

  // Load data when pagination changes
  useEffect(() => {
    getAll(activeFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParameters.get("currentPage"), queryParameters.get("perPage")]);

  // Fetch marketing reports
  const getAll = (filters = {}) => {
    setloading(true);
    let currentPage = queryParameters.get('currentPage')
      ? parseInt(queryParameters.get('currentPage'))
      : 1;
    let perPage = queryParameters.get('perPage')
      ? parseInt(queryParameters.get('perPage'))
      : 10;

    const fromDate = filters.fromDate
      ? DateHelper.formatDate(filters.fromDate, "MM/dd/yyyy")
      : "";

    const toDate = filters.toDate
      ? DateHelper.formatDate(filters.toDate, "MM/dd/yyyy")
      : "";

    reportsService
      .getMarketingReports(currentPage, perPage, fromDate, toDate)
      .then((resp) => {
        setloading(false);
        setPagination({
          pageCount: resp.data.paging?.totalCount,
          currentPage: resp.data.paging?.currentPage,
          perPage: resp.data.paging?.perPage,
          totalCount: resp.data.paging?.totalCount,
        });
        setCrsData(resp.data?.investors);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  function onNavigate(currentPage, perPage) {
    navigate({
      pathname: buildRegionizeRoute(
        `${AppRoutes.Reports}/${AppRoutes.ReportMarketing}`
      ),
      search: `?currentPage=${currentPage}&perPage=${perPage}`,
    });
  }

  const onPageSizeChange = (e) => {
    onNavigate(1, e);
  };

  const onPageChange = (e) => {
    onNavigate(e + 1, pagination.perPage);
  };

  const onDownloadCSV = () => {
    // Format activeFilters to match the filter format expected by FilterHelper.mapToParams
    let filterString = '';
    if (activeFilters.fromDate) {
      const fromDate = DateHelper.formatDate(activeFilters.fromDate, "MM/dd/yyyy");
      filterString += `fromDate=${fromDate}`;
    }
    if (activeFilters.toDate) {
      const toDate = DateHelper.formatDate(activeFilters.toDate, "MM/dd/yyyy");
      if (filterString) filterString += ',';
      filterString += `toDate=${toDate}`;
    }
    let filter = filterString || FilterHelper.mapFilters(queryParameters);
    setloading(true);
    reportsService
      .exportMarketingReport(filter)
      .then((resp) => {
        const date = DateHelper.formatDate(new Date());
        const fileName = `Marketing-Report-${date}.csv`;
        saveAs(resp.data, fileName);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
      });

  };

  // Reset Filters
  const onClear = (formik) => {
    formik.resetForm();
    setActiveFilters({ fromDate: null, toDate: null });
    getAll({});
  };

  return (
    <>
      <Formik
        initialValues={{
          fromDate: null,
          toDate: null,
        }}
        enableReinitialize={true}
        validationSchema={MarketingSchema}
        onSubmit={(values) => {
          setActiveFilters(values);
          getAll(values);
        }}
      >
        {(formik) => (
          <Form>
            <MarketingFilter
              formik={formik}
              onClear={onClear}
              loading={loading}>
            </MarketingFilter>
            {/* Table */}
            <DataTableGrid
              showDownloadCSV={true}
              download={() => {
                onDownloadCSV();
              }}
              pagination={pagination}
              name={'marketingReportTbl'}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
              columns={columns}
              heading={'Marketing Report'}
              records={crsData}
              isPagination={true}
              showEditColumnsButton={true}
              loading={loading}></DataTableGrid>
          </Form>
        )}
      </Formik>
    </>
  );
};
